module.exports = __webpack_public_path__ + "static/media/iv_badge_failed.cdc544fc.svg";